import React from "react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";

export default function CustomerProfile() {
  const { user } = useAuth();
  return (
    <div data-testid="customer-profile">
      <h1 className="font-display text-3xl font-bold">Profile</h1>

      <div className="mt-4 rounded-lg border border-neutral-200 bg-white p-6">
        <div className="flex items-center gap-4">
          {user?.picture ? <img src={user.picture} alt="" className="h-16 w-16 rounded-full" /> : <div className="flex h-16 w-16 items-center justify-center rounded-full bg-lime-400 text-2xl font-black">{(user?.name || "U")[0]?.toUpperCase()}</div>}
          <div>
            <div className="font-display text-xl font-bold">{user?.name}</div>
            <div className="text-sm text-neutral-500">{user?.email}</div>
            <div className="mt-1 inline-block rounded-full bg-lime-100 px-2 py-0.5 text-xs font-bold uppercase tracking-widest text-lime-800">{user?.role}</div>
          </div>
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-3">
          <Stat label="Orders" v="5" />
          <Stat label="Total spent" v="₹34,650" />
          <Stat label="Reviews given" v="3" />
        </div>

        <div className="mt-6 grid gap-4 md:grid-cols-2">
          <F label="Full name" defaultValue={user?.name || ""} />
          <F label="Email" defaultValue={user?.email || ""} />
          <F label="Mobile" defaultValue="+91 98997 47172" />
          <F label="City" defaultValue="Delhi NCR" />
        </div>

        <button onClick={() => toast.success("Profile saved")} className="btn-offset mt-6 rounded-md bg-neutral-950 px-4 py-2 text-sm font-bold text-white hover:bg-neutral-800" data-testid="profile-save">Save changes</button>
      </div>
    </div>
  );
}

function Stat({ label, v }) {
  return (
    <div className="rounded-md border border-neutral-200 p-4">
      <div className="text-xs uppercase tracking-widest text-neutral-500">{label}</div>
      <div className="mt-1 font-display text-2xl font-black">{v}</div>
    </div>
  );
}

function F({ label, defaultValue }) {
  return (
    <div>
      <label className="text-xs font-semibold uppercase tracking-widest text-neutral-600">{label}</label>
      <input defaultValue={defaultValue} className="mt-1 w-full rounded-md border border-neutral-300 px-3 py-2 text-sm" />
    </div>
  );
}
